import { Truck01, Package, MarkerPin01, MessageChatCircle, Zap } from '@untitled-ui/icons-react/build/cjs';
import { transformWidgets as _transformWidgets, WidgetTitleMap } from 'src/utils/widgetSettings.utils';

export const RADAR_WIDGET_IDS = {
    CARRIER_DETAILS: 'carrier-details',
    ORDER_DETAILS: 'order-details',
    LOCATION_UPDATES: 'location-updates',
    INTERNAL_CHAT: 'internal-chat',
    LATEST_ACTIVITY: 'latest-activity',
} as const;

const RADAR_WIDGET_TITLE_DES: WidgetTitleMap = {
    [RADAR_WIDGET_IDS.CARRIER_DETAILS]: {
        title: 'Carrier Details',
        description: 'View carrier information for this order',
        icon: Truck01,
    },
    [RADAR_WIDGET_IDS.ORDER_DETAILS]: {
        title: 'Order Details',
        description: 'View line items and order details',
        icon: Package,
    },
    [RADAR_WIDGET_IDS.LOCATION_UPDATES]: {
        title: 'Location Updates',
        description: 'Track real-time location updates for this order',
        icon: MarkerPin01,
    },
    [RADAR_WIDGET_IDS.INTERNAL_CHAT]: {
        title: 'Internal Chat',
        description: 'Internal team communication for this order',
        icon: MessageChatCircle,
    },
    [RADAR_WIDGET_IDS.LATEST_ACTIVITY]: {
        title: 'Latest Activity',
        description: 'View the latest activity and events for this order',
        icon: Zap,
    },
};

export const DEFAULT_RADAR_WIDGET_SETTINGS: Record<string, { isEnabled: boolean; position: number }> = {
    [RADAR_WIDGET_IDS.CARRIER_DETAILS]: { isEnabled: true, position: 0 },
    [RADAR_WIDGET_IDS.ORDER_DETAILS]: { isEnabled: true, position: 1 },
    [RADAR_WIDGET_IDS.LOCATION_UPDATES]: { isEnabled: true, position: 2 },
    [RADAR_WIDGET_IDS.INTERNAL_CHAT]: { isEnabled: true, position: 3 },
    [RADAR_WIDGET_IDS.LATEST_ACTIVITY]: { isEnabled: true, position: 4 },
};

export const transformRadarWidgets = (widgetsData: any) => {
    const widgets = _transformWidgets(widgetsData, RADAR_WIDGET_TITLE_DES);

    // Append any widgets missing from the user's saved settings — same self-heal as
    // wal-frontend-v2's transformRadarWidgets. Without this, settings saved while the
    // widget modal filtered a widget out (e.g. 'location-updates' on non-in-transit
    // orders, before that gate was widened) drop the key permanently and the section
    // can never render again for that user.
    const existingIds = new Set(widgets.map((w) => w.id));
    const missingWidgets = Object.keys(DEFAULT_RADAR_WIDGET_SETTINGS)
        .filter((id) => !existingIds.has(id))
        .map((id, index) => ({
            id,
            title: RADAR_WIDGET_TITLE_DES[id]?.title || 'Unknown Title',
            description: RADAR_WIDGET_TITLE_DES[id]?.description || 'No description available',
            icon: RADAR_WIDGET_TITLE_DES[id]?.icon,
            isEnabled: true,
            position: widgets.length + index,
        }));

    return [...widgets, ...missingWidgets].sort((a, b) => (a.position || 0) - (b.position || 0));
};
